import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DbProject } from '~src/types/db';
import { useTemplates } from './api-hooks/useTemplates';

/** return current template as dbProject */
export const useCurrentTemplate = () => {
  const { pathname } = useLocation();
  const { data } = useTemplates(undefined, { enabled: false });

  useEffect(() => {
    setCurrentTemplate(parseCurrentTemplate);
  }, [pathname, data]);

  const parseCurrentTemplate = () => {
    const paths = pathname.split('/').filter(Boolean);

    // no current template
    if (!paths[3]) return undefined;

    return data?.find((x) => String(x.id) === paths[3]);
  };

  const [currentTemplate, setCurrentTemplate] = useState<DbProject | undefined>(
    parseCurrentTemplate
  );

  return currentTemplate;
};
